import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-process9",
  "use": "icon-process9-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-process9\"><defs><style type=\"text/css\"></style></defs><path d=\"M277.9 406.7L159.2 612.4c-41.3-14.5-71.1-53.9-71.1-99.9 0-29.1 11.9-55.6 31.1-74.7 19.2-19.2 45.6-31.1 74.7-31.1h84zM415.4 406.7L293.1 618.3h-61l122.2-211.6zM552.9 406.7L430.6 618.3h-61l122.2-211.6z\" fill=\"#CBCBCB\" p-id=\"23037\" /><path d=\"M828.8 641.5H193.9c-71.1 0-129-57.9-129-129s57.9-129 129-129h634.9c71.1 0 129 57.9 129 129s-57.9 129-129 129zM193.9 429.8c-45.6 0-82.7 37.1-82.7 82.7s37.1 82.7 82.7 82.7h634.9c45.6 0 82.7-37.1 82.7-82.7s-37.1-82.7-82.7-82.7H193.9z\" fill=\"#7D7D7D\" p-id=\"23038\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/process9.svg
// module id = 8Ow/
// module chunks = 250